import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { siteConfig } from '../siteData';
import { useWebCourses } from '../hooks/sectionHooks';
import LoadingSpinner from './LoadingSpinner';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const [showCoursesDropdown, setShowCoursesDropdown] = useState(false);
  const [hideTimeout, setHideTimeout] = useState(null);
  const [hideCoursesTimeout, setHideCoursesTimeout] = useState(null);
  const navigate = useNavigate();
  const { data: webCoursesData, isLoading: coursesLoading } = useWebCourses();

  // Get unique course types from data
  const courseTypes = Array.isArray(webCoursesData) 
    ? [...new Set(webCoursesData.map(course => course.course_type))]
    : [];

  const handleShowDropdown = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      setHideTimeout(null);
    }
    setShowAboutDropdown(true);
  };

  const handleHideDropdown = () => {
    const timeout = setTimeout(() => {
      setShowAboutDropdown(false);
    }, 200);
    setHideTimeout(timeout);
  };

  const handleShowCoursesDropdown = () => {
    if (hideCoursesTimeout) {
      clearTimeout(hideCoursesTimeout);
      setHideCoursesTimeout(null);
    }
    setShowCoursesDropdown(true);
  };

  const handleHideCoursesDropdown = () => {
    const timeout = setTimeout(() => {
      setShowCoursesDropdown(false);
    }, 200);
    setHideCoursesTimeout(timeout);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src={siteConfig.logo.src} alt={siteConfig.logo.alt} />
          </Link>
        </div>
        <button 
          className="mobile-menu-button" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className={isMobileMenuOpen ? "hamburger open" : "hamburger"}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <nav className={isMobileMenuOpen ? "nav-open" : ""}>
          <ul className="nav-menu">
            {siteConfig.navigation.map((item, index) => (
              <li 
                key={index}
                className={(item.label === "Бидний тухай" || item.label === "Сургалт") ? "nav-item-with-dropdown" : ""}
                onMouseEnter={() => {
                  if (item.label === "Бидний тухай") handleShowDropdown();
                  if (item.label === "Сургалт") handleShowCoursesDropdown();
                }}
                onMouseLeave={() => {
                  if (item.label === "Бидний тухай") handleHideDropdown();
                  if (item.label === "Сургалт") handleHideCoursesDropdown();
                }}
              >
                <a 
                  href={item.link} 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={item.label === "Суралцагчийн булан" ? "nav-button" : ""}
                  target={item.label === "Суралцагчийн булан" ? "_blank" : undefined}
                  rel={item.label === "Суралцагчийн булан" ? "noopener noreferrer" : undefined}
                >
                  {item.label}
                </a>
                {item.label === "Бидний тухай" && showAboutDropdown && (
                  <div 
                    className="nav-dropdown"
                    onMouseEnter={handleShowDropdown}
                    onMouseLeave={handleHideDropdown}
                  >
                    <button 
                      className="nav-dropdown-item" 
                      onClick={() => {
                        navigate('/teachers');
                        setShowAboutDropdown(false);
                      }}
                    >
                      Багш нар
                    </button>
                  </div>
                )}
                {item.label === "Сургалт" && showCoursesDropdown && (coursesLoading || courseTypes.length > 0) && (
                  <div 
                    className="nav-dropdown"
                    onMouseEnter={handleShowCoursesDropdown}
                    onMouseLeave={handleHideCoursesDropdown}
                  >
                    {coursesLoading && <LoadingSpinner className="loading-indicator-compact" />}
                    {courseTypes.map((type) => (
                      <button 
                        key={type}
                        className="nav-dropdown-item" 
                        onClick={() => {
                          navigate(`/courses?type=${type}`);
                          setShowCoursesDropdown(false);
                        }}
                      >
                        {type} сургалт
                      </button>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
